import {ArrayTemplate, DateField, RequiredField, WorkBookTemplate, YesNoField} from "../common/upload/excel.utils";
import {InputCommercialReleaseData} from "@portbase/bezoekschip-service-typescriptmodels";
import moment from "moment";

export function createDeclarations(data: any[]): InputCommercialReleaseData[] {
  return data.map(r => (<InputCommercialReleaseData>{
    consignmentNumber: r.consignmentNumber,
    equipmentNumber: r.equipmentNumber,
    crn: r.crn,
    empty: r.empty,
    containerOperatorCode: r.containerOperatorCode,
    inlandOperatorEanCode: r.inlandOperatorEanCode,
    releaseDeadline: r.releaseDeadline,
    releaseToPartyCode: r.releaseToPartyCode,
    terminalCode: r.terminalCode,
    remarks: r.remarks,
    releaseModality: r.releaseModality,
    releaseReference: r.releaseReference
  }));
};

export const commercialReleaseTemplate: WorkBookTemplate = {
  sheets: [
    {
      name: 'Commercial Releases',
      template: {
        releases: new ArrayTemplate({
          consignmentNumber: new RequiredField('A$'),
          equipmentNumber: new RequiredField('B$'),
          containerOperatorCode: new RequiredField('C$'),
          releaseToPartyCode: new RequiredField('D$'),
          crn: 'E$',
          empty: new YesNoField('F$'),
          inlandOperatorEanCode: 'G$',
          releaseDeadline: new DateField('H$', undefined, moment.defaultFormat),
          terminalCode: 'I$',
          releaseModality: 'J$',
          releaseReference: 'K$',
          remarks: 'L$',
        }, [2, 20000])
      }
    }
  ]
};
